import requests from "./httpService";

const PolicyServices = {
 
  getPolicyById: async (id, body) => {
    return requests.get(`/hourRentalPolicy/${id}`, body);
  },

  updatePolicy: async (id, body) => {
    return requests.put(`/hourRentalPolicy/update/${id}`, body);
  },

  
};

export default PolicyServices;
